// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5j-2";
export var blackBorderOnHover = "_5j-7";
export var cell = "_5j-6";
export var cellContainer = "_5j-3";
export var checked = "_5j-8";
export var disabled = "_5j-5";
export var featuredIconCellContainer = "_5j-9";
export var featuredIconTextContainer = "_5j-b";
export var featuredIconWrapper = "_5j-a";
export var noBorder = "_5j-c";
export var orangeSelectedRow = "_e7-3";
export var overflowableText = "_5j-0";
export var overflowableTextContainer = "_5j-1";
export var row = "_5i-0";
export var rowCheckboxCell = "_5j-4";
export var selectableTable = "_e7-2";